import styled from 'styled-components';
import {mobileThreshold} from "../../../../../../Constants/layoutValues";
import {cssVarColors} from "../../../../../../Constants";

export const SocialButtonWrapper = styled.div`
	padding-left: 0.75em;
	padding-right: 0.75em;
	cursor: pointer;
	
	&:hover
	{
		color: ${cssVarColors.highlight};
	}
	
	@media (max-width: ${mobileThreshold}px)
	{
		padding-left: .15em;
		padding-right: .15em;
	}
`;
